import React from 'react'
import './Agrid.css'

function Agrid() {
  return (
    <div className='container bg-dark mt-5 rounded-3 '>
        <div className="row">
            <div className="col-12 text-center">
       <img src="https://www.kfcpakistan.com/static/media/mitaobhook_new.69e619b89226c989f8bd.png" className='aimg img-fluid ' alt="" />
       <p className='text-light'>is KFC’s pledge to give back to society. Over the years we have made it our mission to spread the message of hope, bringing positive<br></br> change in the lives of people and providing better living standards. Mitao Bhook strengthens the community on the pillars of Education,<br></br> Inclusion & Diversity.</p>
</div>
</div>
    </div>
  )
}

export default Agrid
